export default {
	props: {
		field: [Object, Array, String],
		value: {
			type: [String, Number, Array, Boolean],
			default: ''
		},
	},
	data() {
		return {
			name: this.getName(),
			placeholder: this.getPlaceHolder(),
			required: this.isRequired(),
			readonly: this.isReadOnly(),
			disabled: this.isDisabled(),
			id: this.getID(),
			focused: false,
			currentValue: this.value,
			selectOptions: this.getOptions()
		}
	},
	methods: {
		/**
		 * Retrieve the name parameter for the field.
		 */
		getName() {
			return this.field.id
		},
		/**
		 * Retrieve the placeholder for the field.
		 */
		getPlaceHolder() {
			return this.field.placeholder ? this.field.placeholder : false
		},
		/**
		 * Check if the field is required.
		 */
		isRequired() {
			return this.field.required === true ? true : false
		},
		/**
		 * Check if the field is set as readonly.
		 */
		isReadOnly() {
			return this.field.readonly ? true : false
		},
		/**
		 * Check if the field is disabled.
		 */
		isDisabled() {
			return this.field.disabled ? true : false
		},
		/**
		 * Retrieve the ID parameter for this field.
		 */
		getID() {
			return this.getName()
		},
		/**
		 * Get options available for this field.
		 */
		getOptions() {
			return this.field.options ? this.field.options : false
		},
		/**
		 * Handle input change on the field.
		 *
		 * @param {any} event
		 */
		handleInput(event) {
			let value = event.target.value;
			this.$emit('input', value);
			this.setCurrentValue(value);
			this.$emit('on-change', event);
		},
		handleChange(event) {
			if( this.field.type === 'checkbox' ) {
				this.$emit('input', event.target.checked);
			}
			this.$emit('on-input-change', event);
		},
		/**
		 * Change the value of the field.
		 *
		 * @param {any} value
		 * @returns {any}
		 */
		setCurrentValue(value) {
			if (value === this.currentValue) return;
			this.$nextTick(() => {
				//this.resizeTextarea();
			});
			this.currentValue = value;
		},

		/**
		 * Handle focus and blur events.
		 */
		focus() {
			(this.$refs.input || this.$refs.textarea).focus();
		},
		handleBlur(event) {
			this.focused = false;
			this.$emit('blur', event);
		},
		handleFocus(event) {
			this.focused = true;
			this.$emit('focus', event);
		},
	},
	watch: {
		/**
		 * Watch for changes on the value and update local value.
		 *
		 * @param {any} val
		 */
		value(val) {
			this.setCurrentValue(val);
		}
	},
	computed: {
		/**
		 * Generate a list of attributes for the field.
		 */
		attributes() {
			return [ 'id', 'placeholder', 'readonly', 'disabled']
				.filter(prop => this[prop] !== false)
				.reduce((attributes, attr) => {
					attributes[attr] = this[attr]
					return attributes
				}, {})
		},
	},
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-formit-fields/src/mixins/basefield.js
// module id = JHA3
// module chunks = 0